import React, { useState } from 'react';
import loginStyle from './CoordinatorLoginPage.module.css'
import logo from '../../../assets/images/brandlogo.png'
import { FaEye, FaEyeSlash } from 'react-icons/fa';
import { FaUserLarge } from "react-icons/fa6";
import { FaLock } from "react-icons/fa6";
import { Link, useNavigate, useLocation } from 'react-router-dom';
import CoordinatorRegisterPage from './CoordinatorRegisterPage';
import { useDispatch } from 'react-redux';
import { BASE_URL } from '../../../config';
import { setCoordinator } from '../../../redux/slices/coordinatorSlices';
import Swal from "sweetalert2";
require('typeface-poppins')

const CoordinatorLoginPage = () => {

	const navigate = useNavigate();
	const location = useLocation();
	const dispatch = useDispatch();
	const [formData, setFormData] = useState({
		email: '',
		password: ''
	});
	const [error, setError] = useState('');

	// Eye	
	const [isPasswordVisible, setPasswordVisible] = useState(false);
	const togglePasswordVisibility = () => {
		setPasswordVisible(!isPasswordVisible);
	};

	const handleChange = (e) => {
		setFormData({
			...formData,
			[e.target.name]: e.target.value
		});
	};

	const handleSubmit = async (e) => {
		e.preventDefault();
		setError('');

		try {
			//const BASE_URL = process.env.REACT_APP_API_BASE_URL;
			// console.log("BASE_URL: ", process.env.REACT_APP_API_BASE_URL);
			const response = await fetch(`${BASE_URL}authormeetapi/cordinator_login.php`, {
				method: 'POST',
				headers: {
					'Content-Type': 'application/json',
				},
				body: JSON.stringify(formData),
			});

			const data = await response.json();

			if (data.success) {
				// Store all necessary data
				localStorage.setItem('coordinatorToken', data.coordinatorToken);
				localStorage.setItem('cordinator_id', data.user);
				localStorage.setItem('coordinatorEmail', data.email);
				localStorage.setItem('coordinatorFName', data.f_name);
				localStorage.setItem('coordinatorLName', data.l_name);
				localStorage.setItem('coordinatorPosition', data.position);
				localStorage.setItem('coordinatorPic', data.pic);
				sessionStorage.setItem('isLoggedIn', 'true');

				dispatch(setCoordinator({
					id: data.user,
					fName: data.f_name,
					lName: data.l_name,
					email: data.email,
					position: data.position,
					pic: data.pic,
				}));

				// Show success message
				Swal.fire({
					title: "Login Successful!",
					text: "Redirecting to dashboard...",
					icon: "success",
					timer: 2000,
					showConfirmButton: false,
				}).then(() => {
					// Redirect to dashboard
					navigate('/coordinator-dashboard', { replace: true });
				});
			} else {
				//setError(data.message || 'Invalid credentials');
				// Show success message
				Swal.fire({
					title: "Failure!",
					text: "Invalid credentials",
					icon: "error",
					timer: 2500,
					showConfirmButton: false,
				})
			}
		} catch (err) {
			Swal.fire({
				title: "Failure!",
				text: "An error occurred. Please try again.",
				icon: "error",
				timer: 2500,
				showConfirmButton: false,
			})
		}
	};

	return (
		<>
			<div className={loginStyle.authincationMain}>
				<div className="container h-100">
					<div className="row justify-content-center h-100 align-items-center">
						<div className="col-md-6">
							<div className={loginStyle.authincationContent}>
								<div className="row no-gutters">
									<div className="col-xl-12">
										<div className={loginStyle.authForm}>
											<div className="text-center mb-3">
												<a href="#" className={loginStyle.brandLink}>
													<img src={logo} alt="BrandLogo" />
													<div className={loginStyle.brandInfo}>
														<span> AuthorMeet </span>
														<small> Powered by: &nbsp; Bookworm Central </small>
													</div>
												</a>
											</div>
											<h4 className={loginStyle.brandTitle}> Coordinators sign in </h4>
											<form onSubmit={handleSubmit}>
												<div className={`${loginStyle.inputIconboxes} input-group mb-4`}>
													<span className={`${loginStyle.inputIcon} input-group-text`}>
														<FaUserLarge className={loginStyle.primaryColor} />
													</span>
													<input type="email" className={`${loginStyle.inputFeild} form-control`} placeholder="Email Address" name="email" onChange={handleChange} required />
												</div>
												<div className={`${loginStyle.inputIconboxes} input-group mb-3`}>
													<span className={`${loginStyle.inputIcon} input-group-text`}>
														<FaLock className={loginStyle.primaryColor} />
													</span>
													<input type={isPasswordVisible ? "text" : "password"} className={`${loginStyle.inputFeild} form-control`} placeholder="Password" name="password" onChange={handleChange} required />
													<div className={loginStyle.toggleButton} onClick={togglePasswordVisibility}>
														{isPasswordVisible ? <FaEyeSlash className={loginStyle.eyeIcon} /> : <FaEye className={loginStyle.eyeIcon} />}
													</div>
												</div>
												<div className={`${loginStyle.forgotPassword} form-group text-center mb-3`}>
													<a href="#"> Forgot Password? </a>
												</div>
												<div className="form-row d-flex justify-content-between mt-3 mb-3 d-none d-lg-block">
													<div className="form-group">
														<div className="custom-control custom-checkbox ml-1">
															<input type="checkbox" className="custom-control-input me-2" id="" />
															<label className={`${loginStyle.rememberMe} custom-control-label`}> Remember me </label>
														</div>
													</div>
												</div>
												<div className={`${loginStyle.newAccount} ${loginStyle.mobilnewAccount} mb-4 mt-5`}>
													<p className='mb-0'> Create new account?
														<Link to="/coordinator-register" element={<CoordinatorRegisterPage />}> Register here </Link>
													</p>
												</div>
												<div className="text-center">
													{error && <div className="error-message">{error}</div>}
													<button type="submit" className={`${loginStyle.authorSigninBtn} btn btn-warning`}>Login</button>
												</div>
											</form>
											<div className={`${loginStyle.newAccount} ${loginStyle.desktopnewAccount}`}>
												<p className='mb-0'> Create new account? <Link to="/coordinator-register" element={<CoordinatorRegisterPage />}> Sign Up </Link></p>
											</div>
										</div>
									</div>
								</div>
							</div>
						</div>
					</div>
				</div>
			</div>
		</>
	);
};

export default CoordinatorLoginPage;